export interface UserMessage {
  id: string
  avatar: string
  message: string
  timestamp: string
}

export const marqueeConfig = {
  speed: 37.5, // px per second for react-fast-marquee
  scrollThreshold: 80, // Start fading when within 80px of the top
  messages: [
    {
      id: "1",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-1.avif",
      message: "buy me the top 3 golfers in the Masters",
      timestamp: "1m ago",
    },
    {
      id: "2",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-2.avif",
      message: "who's up in Champions League rn?",
      timestamp: "3m ago",
    },
    {
      id: "3",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-3.avif",
      message: "How are Lakers looking this quarter?",
      timestamp: "5m ago",
    },
    {
      id: "4",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-4.avif",
      message: "Grab me 500 shares of Eagles to win Super Bowl",
      timestamp: "8m ago",
    },
    {
      id: "5",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-5.avif",
      message: "Wimbledon finals predictions?",
      timestamp: "12m ago",
    },
    {
      id: "6",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-6.avif",
      message: "Put 3,000 on Dallas to win Super Bowl",
      timestamp: "15m ago",
    },
    {
      id: "7",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-7.avif",
      message: "Formula 1 race tmrw, thoughts?",
      timestamp: "18m ago",
    },
    {
      id: "8",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-8.avif",
      message: "Sell half my Jets position here!",
      timestamp: "22m ago",
    },
    {
      id: "9",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-9.avif",
      message: "What's @knicksfan1 holding?",
      timestamp: "25m ago",
    },
    {
      id: "10",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-10.avif",
      message: "What are live odds for the NBA finals?",
      timestamp: "31m ago",
    },
    {
      id: "12",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-11.avif",
      message: "Who's trending in MLB right now?",
      timestamp: "35m ago",
    },
    {
      id: "13",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-12.avif",
      message: "max bet Ohtani for MVP",
      timestamp: "39m ago",
    },
    {
      id: "14",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-13.avif",
      message: "Predicting any upsets in March Madness?",
      timestamp: "42m ago",
    },
    {
      id: "15",
      avatar: "https://a.bracky.app/assets/landing/avatars/marquee-avatar-14.avif",
      message: "How are my positions looking?",
      timestamp: "45m ago",
    },
  ] as UserMessage[],
  gradient: {
    background:
      "linear-gradient(to bottom, rgba(10,17,41,1) 0%, rgba(10,17,41,0.98) 5%, rgba(10,17,41,0.95) 10%, rgba(10,17,41,0.9) 15%, rgba(10,17,41,0.8) 25%, rgba(10,17,41,0.65) 35%, rgba(10,17,41,0.5) 45%, rgba(10,17,41,0.35) 60%, rgba(10,17,41,0.2) 75%, rgba(10,17,41,0.1) 85%, rgba(10,17,41,0.05) 92%, rgba(10,17,41,0.02) 96%, rgba(10,17,41,0.01) 98%, transparent 100%)",
  },
  classes: {
    container: "relative z-501",
    backdrop: "fixed top-0 left-0 w-full h-24 pointer-events-none transition-opacity duration-100 ease-out",
    messageButton:
      "flex items-center mx-[.7rem] text-white/80 text-sm cursor-pointer hover:text-white/90 transition-colors bg-transparent border-none p-0 group",
    avatar: "w-5 h-5 translate-y-[.05rem] rounded-full mr-[.6rem] object-cover",
    brackyLabel: "font-medium text-white",
    timestamp: "text-white/50 group-hover:text-white/60 ml-[.2rem] transition-colors",
    arrow: "text-white/30 group-hover:text-white/60 w-[.95rem] translate-y-[.085rem] h-[.95rem] ml-1 transition-colors",
  },
  truncateLength: 35,
  twitterUrl: "https://x.com/brackethq",
}
